import { isUndNullEmpNew } from '../../helpers/UtilsHelper';

export class LoginClass {
    constructor(
        email = '',
        password = '',
        rememberMe = false,
    ) {
        this.email = email;
        this.password = password;
        this.rememberMe = rememberMe;
    };

    static getClassName = () => {
        return 'Login - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this.getClassName() })?.result) {
            return new LoginClass(
                obj?.email,
                obj?.password,
                obj?.rememberMe,
            );
        }

        return new LoginClass();
    }
}